import { log } from '@hotjar/insights-common/lib/log';

/**
 * @deprecated Please import this function from `@hotjar/tracking` under the `googleAnalytics` namespace.
 * Track that a user signed up.
 */
export const trackSignup = (plan: string): void => {
  log.debug(`GA: Tracking sign-up: ${plan}`);

  window.ga?.('send', {
    hitType: 'event',
    eventAction: 'Sign-up',
    eventCategory: 'Account',
    eventLabel: plan,
  });
};

/**
 * @deprecated Please import this function from `@hotjar/tracking` under the `googleAnalytics` namespace.
 * Track an event using the 'Account' category in GA.
 */
export const trackAccountEvent = (eventName: string, label?: string): void => {
  log.debug(`GA: Tracking (Account) event: ${eventName}`);

  const options = label
    ? {
        eventLabel: label,
      }
    : {};

  window.ga?.('send', {
    hitType: 'event',
    eventAction: eventName,
    eventCategory: 'Account',
    ...options,
  });
};

/**
 * @deprecated Please import this function from `@hotjar/tracking` under the `googleAnalytics` namespace.
 * Track an event using the 'Created Item' category in GA.
 */
export const trackCreatedItemEvent = (eventName: string): void => {
  log.debug(`GA: Tracking (Created Item) event ${eventName}`);

  window.ga?.('send', {
    hitType: 'event',
    eventAction: eventName,
    eventCategory: 'Created Item',
  });
};

/**
 * @deprecated Please import this function from `@hotjar/tracking` under the `googleAnalytics` namespace.
 * Track that a user has become a customer (he has paid us money for the first time).
 *
 * @param totalCost The total cost which the user spent on the first purchase.
 */
export const trackNewCustomer = (totalCost: number): void => {
  log.debug('GA: Tracking new customer');

  window.ga?.('send', {
    hitType: 'event',
    eventAction: 'New customer',
    eventCategory: 'Account',
    eventValue: totalCost,
  });
};

/**
 * @deprecated Please import this function from `@hotjar/tracking` under the `googleAnalytics` namespace.
 * Track users who clicked the "Sign up With Google" on a sign up page.
 */
export const trackSignUpWithGoogle = (): void => {
  log.debug('GA: Sign up with Google');

  window.ga?.('send', {
    hitType: 'event',
    eventAction: 'Sign up with Google',
    eventCategory: 'Account',
  });
};
